import RequestSchedule from "@/features/foot-watch/components/forms/RequestSchedule";
import { createFileRoute } from "@tanstack/react-router";
import { CalendarPlus } from "lucide-react";
import PrettyRequestWrapper from "../../components/common/PrettyRequestWrapper";

export const Route = createFileRoute("/schedules/request")({
    component: () => (
        <PrettyRequestWrapper
            icon={<CalendarPlus className="mb-2 w-10 h-10 text-indigo-500" />}
            title="Request a New Schedule"
            description="Need a custom schedule for your workflow? Fill out the form below and our team will review your request."
        >
            <RequestSchedule />
        </PrettyRequestWrapper>
    ),
});
